



































import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import {CoreSet, ExpansionsList} from "@/consts/expansions";
// eslint-disable-next-line no-unused-vars
import {Hero} from "@/types/hero";

// eslint-disable-next-line no-unused-vars
import {Expansion} from "@/types/expansion";
import {mapActions, mapGetters, mapState} from "vuex";

type SettingsData = {
  allExpansions: Expansion[],
  playerSelections: string[],
  numGames: number
}

export default Vue.extend({
  name: 'ChooseSettings',
  data () : SettingsData {
    return {
      allExpansions: ExpansionsList,
      numGames: 4,
      playerSelections: ['', '', '', ''],
    }
  },
  async created () {
    const expansions = window.localStorage.getItem('expansions')
    if (expansions) {
      const names = expansions.split(',')
      names.forEach((name) => {
        this._toggleExpansion(name)
      })
    } else {
      this._toggleExpansion(CoreSet.name)
    }

    this.numGames = 5
    const numStoredStr = window.localStorage.getItem('numGames')

    if (numStoredStr) {
      const numStored = parseInt(numStoredStr)

      if (numStored && !isNaN(numStored)) {
        this.numGames = numStored
      }
    }

    // TESTING
    let hash = window.location.hash
    hash = hash.replaceAll('#', '')
    hash = hash.replaceAll('/', '')
    if (hash && hash.length) {
      await this.$store.dispatch('enableAllExpansions')
      this.playerSelections = hash.split(',').map(decodeURIComponent)
      this.startRun()
    }
  },
  computed: {
    ...mapState({
      expansions: 'expansions',
      players: 'players'
    }),
    ...mapGetters({
      heroes: 'heroes',
      expansionNames: 'expansionNames'
    }),
    ...mapActions({
      toggleExpansion: 'toggleExpansion'
    })
  },
  methods: {
    _toggleExpansion (name: string) {
      this.$store.dispatch('toggleExpansion', name)
    },
    async startRun () {
      try {
        window.localStorage.setItem('expansions', this.expansionNames.join(','))
        window.localStorage.setItem('numGames', this.numGames.toString())
      } catch (ex) {
        console.log(ex)
      }

      if (!this.expansions.length) {
        alert('Expansions needed')
        return
      }
      if (this.players[0] == '') {
        alert('First player needed')
        return
      }

      await this.$store.dispatch('createPlayers', this.playerSelections)
      await this.$store.dispatch('startRun', {
        numGames: this.numGames
      })
    },
    selectHero (playerIdx: number, hero: Hero) {
      if (this.playerSelections[playerIdx] == hero.name) {
        Vue.set(this.playerSelections, playerIdx, '')
      } else {
        for (var i = 0; i < this.playerSelections.length; i++) {
          if (this.playerSelections[i] == hero.name) {
            return
          }
        }
        Vue.set(this.playerSelections, playerIdx, hero.name)
      }
    },
  }
});
